import { useParams } from 'react-router-dom';

import { gql, TypedDocumentNode, useSuspenseQuery } from '@apollo/client';

interface Data {
  portfolioDetail: {
    id: number;
    mappingId: string;
    mappingCompany: {
      mappingId: string;
      name: string;
      serviceName: string;
      ceo: string;
      capital: number;
      bizNo: string;
      establishmentDate: string;
    };
    investInfos: {
      id: number;
      faceValue: number;
      totalShares: number;
      investDate: string;
      investmentUnitPrice: number;
      shareholding: number;
      investmentAmount: number;
      stockType: string;
    }[];
    investSummary: {
      lastInvestDate: string;
      totalInvestmentCount: number;
      shareholdingCount: number;
      totalInvestmentAmount: number;
      lastCorporateValue: number;
      accumulatedIssuanceQuantity: number;
      equityValue: number;
    };
    assigneeInfos: {
      id: number;
      email: string;
    }[];
  };
}

interface Variables {
  groupId: string;
  portfolioId: string;
}

export const usePortfolioDetail = () => {
  const { groupId, portfolioId } = useParams();

  const PORTFOLIO_DETAIL: TypedDocumentNode<Data, Variables> = gql`
    query PortfolioDetail($groupId: String, $portfolioId: String) {
      portfolioDetail(groupId: $groupId, portfolioId: $portfolioId) {
        id
        mappingId
        mappingCompany {
          mappingId
          name
          serviceName
          ceo
          capital
          bizNo
          establishmentDate
        }
        investInfos {
          id
          faceValue
          totalShares
          investDate
          investmentUnitPrice
          shareholding
          investmentAmount
          stockType
        }
        assigneeInfos {
          id
          email
        }
        investSummary {
          lastInvestDate
          totalInvestmentCount
          shareholdingCount
          totalInvestmentAmount
          lastCorporateValue
          accumulatedIssuanceQuantity
          equityValue
        }
      }
    }
  `;

  const { data, refetch, error } = useSuspenseQuery(PORTFOLIO_DETAIL, {
    variables: {
      groupId: String(groupId),
      portfolioId: String(portfolioId),
    },
    fetchPolicy: 'no-cache',
    errorPolicy: 'none',
  });

  const currentState = {
    data: data?.portfolioDetail,
    refetch,
    error,
  };

  return currentState;
};
